import { v4 as uuidv4 } from 'uuid';
import { CultureTextModel } from './form';
import { formatMessageByCulture } from '../../utilities/CultureUtilities';

export class Option {
  public text: CultureTextModel[] | string;
  public value: string;

  constructor(cultures: string[]) {
    this.value = uuidv4();
    this.text = [];

    for (const culture of cultures) {
      this.text.push({ culture, value: formatMessageByCulture('toolbox.labels.option', culture) });
    }
  }
}
